import { Prescription } from '@/custom/menicon/models';
import { GenericService } from '@/services/api/generic.service';

export class JourneyPrescriptionService extends GenericService<Prescription> {

  constructor(patientId: string, journeyId: string) {
    super(`/menicon/v1/patients/${patientId}/journeys/${journeyId}/prescriptions`);
  }
}
